let backendHost;

const HOST_NAME = window && window.location && window.location.hostname;

let tal_front_end = require("../utils/config/keys").TAL_FRONTEND;
let tal_back_end = require("../utils/config/keys").TAL_BACKEND;
let cert_front_end= require("../utils/config/keys").CERT_FRONTEND;
let cert_back_end = require("../utils/config/keys").CERT_BACKEND;
let prod_front_end = require("../utils/config/keys").PROD_FRONTEND;
let prod_front_end_temp = require("../utils/config/keys").PROD_FRONTEND_TEMP;
let prod_back_end = require("../utils/config/keys").PROD_BACKEND;
let local_front_end = require("../utils/config/keys").LOCAL_FRONTEND;
let local_back_end = require("../utils/config/keys").LOCAL_BACKEND;

if (HOST_NAME === tal_front_end) {
  backendHost = tal_back_end;
}else if (HOST_NAME === cert_front_end) {
  backendHost = cert_back_end;
} else if (HOST_NAME === prod_front_end || HOST_NAME === prod_front_end_temp) {
  backendHost = prod_back_end;
} else if (HOST_NAME === local_front_end) {
  backendHost = local_back_end;
} else {
  backendHost = tal_back_end;
}

export const API_ROOT = `${backendHost}`;
